<div class="footer container">
  <div class="row justify-content-between">
    <div class="col-12 col-md-9 text-center text-md-left footer-company">
      <ul>
        <li class="headitem">{{ 'Company' | translate }}</li>
        <li *ngIf="showContact">
          <a [attr.href]="contactLink" (click)="contact()">{{ 'Contact' | translate }}</a>
        </li>
        <li *ngIf="showPrivacyLink">
          <a [attr.href]="privacyLink" (click)="privacy()">{{ 'Privacy' | translate }}</a>
        </li>
        <li *ngIf="showImprintLink" >
          <a [attr.href]="imprintLink" (click)="impressum()">{{ 'Imprint' | translate }}</a>
        </li>
      </ul>
    </div>
    <div *ngIf="showTermsConditionsLink" class="col-12 col-md-3 text-center text-md-right footer-information">
      <ul>
        <li class="headitem">{{ 'Information' | translate }}
        </li>
        <li>
          <a [attr.href]="termsConditionsLink" (click)="agb()">{{ 'Terms & Conditions' | translate }}</a>
        </li>
      </ul>
    </div>
    <div *ngIf="isPaymentProviderExist"class="col-12 order-3 order-lg-3 col-lg footer-pay text-center my-3 my-lg-0">
      <img *ngIf="isOgonePayment || isPayonePayment || isStripePayment" src="assets/svg/visa3.svg">
      <img *ngIf="isOgonePayment || isPayonePayment || isStripePayment" src="assets/svg/mastercard3.svg">
      <img *ngIf="isSofortPayment" src="assets/svg/sofort3.svg">
      <img *ngIf="isPaypalPayment" src="assets/svg/paypal3.svg">
    </div>
  </div>
</div>
